angular.module("vgresiduos").directive("disposalResponsible", function () {
	return {
		scope: true,
		controller: "DisposalResponsibleCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalResponsible/disposalResponsible_template.html"
	};
});
